import React from 'react';

export function WorkstreamLegend({ workstreams = [] }) {
  if (!workstreams.length) return null;

  return (
    <div className="flex flex-wrap gap-3 text-xs text-muted-foreground" data-testid="workstream-legend">
      {workstreams.map((ws) => (
        <div
          key={ws.id}
          className="flex items-center gap-1.5"
          data-testid={`workstream-legend-item-${ws.slug}`}
        >
          <span
            className="h-2.5 w-2.5 rounded-full shrink-0"
            style={{ backgroundColor: ws.color }}
          />
          <span>{ws.name}</span>
        </div>
      ))}
    </div>
  );
}
